
// // // import React, { useState, useEffect } from 'react';
// // // import axios from 'axios';
// // // import './Catalog1.css';
// // // import DetailsCard1 from '../detailsCard/DetailsCard1';

// // // import Pagination from '../../AllCorrectPages/Pagination/Pagination';
// // // import * as XLSX from 'xlsx';

// // // const backendURL = process.env.REACT_APP_backend_url;

// // // const Catalog = () => {
// // //   const [filteredProjects, setFilteredProjects] = useState([]);
// // //   const [filters, setFilters] = useState({ Type: '', Department: '', Year: '' });
// // //   const [departments, setDepartments] = useState([]);
// // //   const [searchPerformed, setSearchPerformed] = useState(false);
// // //   const [currentPage, setCurrentPage] = useState(1);
// // //   const [loading, setLoading] = useState(false);
// // //   const [error, setError] = useState('');
// // //   const projectsPerPage = 9;
  
// // //   const mtechDepartments = ['CE-SE', 'CE-HE', 'CE-GTE', 'EE-PE', 'EE-PS', 'ME-CC', 'ME-AMS', 'EE-ES', 'EE-VLSI', 'CSE-SE', 'CSE-CNIS', 'EIE', 'CSE'];
// // //   const btechDepartments = [
// // //     'IT', 'CSE', 'ECE', 'ME', 'EIE', 'CE', 'EEE', 'AIML',
// // //     'CS-AIML', 'CS-DS', 'CS-IOT', 'CS-CyS',
// // //     'AI & DS', 'CSBS', 'AE'
// // //   ];
  
// // //   useEffect(() => {
// // //     setDepartments(filters.Type === 'MTech-Major' ? mtechDepartments : filters.Type === 'BTech-Major' ? btechDepartments : []);
// // //     if (filters.Department) { setFilters(prev => ({ ...prev, Department: '' })); }
// // //   }, [filters.Type]);

// // //   const handleChange = (e) => {
// // //     const { name, value } = e.target;
// // //     setFilters(prev => ({ ...prev, [name]: value }));
// // //   };

// // //   const handleSubmit = async (e) => {
// // //     e.preventDefault();
// // //     setSearchPerformed(true);
// // //     setCurrentPage(1);
// // //     setLoading(true);
// // //     setError('');
// // //     setFilteredProjects([]);
// // //     try {
// // //       const response = await axios.post(`${backendURL}/filter`, { query: filters }, { 
// // //         headers: { 'Content-Type': 'application/json' }
// // //       });
// // //       setFilteredProjects(Array.isArray(response.data) ? response.data : []);
// // //     } catch (err) {
// // //       console.error("Error fetching data: ", err);
// // //       setError('Failed to fetch projects. Please check network or try again.');
// // //       setFilteredProjects([]);
// // //     } finally {
// // //       setLoading(false);
// // //     }
// // //   };

// // //   const handleDownloadAll = () => {
// // //     if (filteredProjects.length === 0) {
// // //       alert('No projects to download');
// // //       return;
// // //     }

// // //     const excelData = filteredProjects.map(project => {
// // //       const students = project.AdditionalInfo?.StudentNames || 'N/A';
// // //       const htNos = project.AdditionalInfo?.HTNos || 'N/A';
      
// // //       return {
// // //         'Project ID': project.ProjectId,
// // //         'Title': project.ProjectTitle,
// // //         'Supervisor': project.ProjectSupervisor,
// // //         'Department': project.Department,
// // //         'Type': project.Project_Type,
// // //         'Year': project.Year,
// // //         'Domain': project.AdditionalInfo?.Domain || 'N/A',
// // //         'Students': students,
// // //         'Hall Ticket Numbers': htNos
// // //       };
// // //     });

// // //     const ws = XLSX.utils.json_to_sheet(excelData);
// // //     const wb = XLSX.utils.book_new();
// // //     XLSX.utils.book_append_sheet(wb, ws, "Projects");
// // //     XLSX.writeFile(wb, `Projects_${new Date().toISOString().split('T')[0]}.xlsx`);
// // //   };

// // //   const handleDownloadSingle = (project) => {
// // //     const students = project.AdditionalInfo?.StudentNames || 'N/A';
// // //     const htNos = project.AdditionalInfo?.HTNos || 'N/A';
    
// // //     const excelData = [{
// // //       'Project ID': project.ProjectId,
// // //       'Title': project.ProjectTitle,
// // //       'Supervisor': project.ProjectSupervisor,
// // //       'Department': project.Department,
// // //       'Type': project.Project_Type,
// // //       'Year': project.Year,
// // //       'Domain': project.AdditionalInfo?.Domain || 'N/A',
// // //       'Students': students,
// // //       'Hall Ticket Numbers': htNos
// // //     }];

// // //     const ws = XLSX.utils.json_to_sheet(excelData);
// // //     const wb = XLSX.utils.book_new();
// // //     XLSX.utils.book_append_sheet(wb, ws, "Project");
// // //     XLSX.writeFile(wb, `Project_${project.ProjectId}.xlsx`);
// // //   };

// // //   // Pagination logic
// // //   const indexOfLastProject = currentPage * projectsPerPage;
// // //   const indexOfFirstProject = indexOfLastProject - projectsPerPage;
// // //   const currentProjects = Array.isArray(filteredProjects) ? filteredProjects.slice(indexOfFirstProject, indexOfLastProject) : [];
// // //   const totalPages = Array.isArray(filteredProjects) ? Math.ceil(filteredProjects.length / projectsPerPage) : 0;
// // //   const paginate = (pageNumber) => { 
// // //     if (pageNumber > 0 && pageNumber <= totalPages) { 
// // //       setCurrentPage(pageNumber); 
// // //       window.scrollTo(0, 0); 
// // //     } 
// // //   };

// // //   return (
// // //     <div className="catalog-page-container">
// // //       <div className="catalog-filter-card">
// // //         <h1 className="catalog-title">Catalog</h1>
// // //         <p className="catalog-subtitle">Your Inspiration Starts Here</p>
// // //         <form onSubmit={handleSubmit} className="catalog-form">
// // //           <div className="filter-item">
// // //             <select name="Type" value={filters.Type} onChange={handleChange} className="catalog-select">
// // //               <option value="">Select Type</option>
// // //               <option value="BTech-Major">BTech-Major</option>
// // //               <option value="MTech-Major">MTech-Major</option>
// // //             </select>
// // //           </div>
// // //           <div className="filter-item">
// // //             <select name="Department" value={filters.Department} onChange={handleChange} disabled={!filters.Type} className="catalog-select">
// // //               <option value="">Select Department</option>
// // //               {departments.map((dept) => ( 
// // //                 <option key={dept} value={dept}>{dept}</option>
// // //               ))}
// // //             </select>
// // //           </div>
// // //           <div className="filter-item">
// // //             <select name="Year" value={filters.Year} onChange={handleChange} className="catalog-select">
// // //               <option value="">Select Year</option>
// // //               {[2024, 2023, 2022, 2021, 2020].map((year) => ( 
// // //                 <option key={year} value={year}>{year}</option>
// // //               ))}
// // //             </select>
// // //           </div>
// // //           <div className="filter-item">
// // //             <button type="submit" disabled={loading} className="catalog-button">
// // //               {loading ? 'Filtering...' : 'Filter'}
// // //             </button>
// // //           </div>
// // //           {filteredProjects.length > 0 && (
// // //             <div className="filter-item">
// // //               <button 
// // //                 type="button" 
// // //                 onClick={handleDownloadAll}
// // //                 disabled={loading}
// // //                 className="catalog-button download-all-button"
// // //               >
// // //                 Download All
// // //               </button>
// // //             </div>
// // //           )}
// // //         </form>
// // //       </div>

// // //       <div className="catalog-results-area">
// // //         {loading && <div className="catalog-loading">Loading projects...</div>}
// // //         {error && <div className="catalog-error">{error}</div>}
// // //         {searchPerformed && !loading && !error && (
// // //           <>
// // //             {/* {filteredProjects.length === 0 ? (
// // //               <div className="catalog-no-results">No projects found matching your criteria.</div>
// // //             ) : (
// // //               <>
// // //                 {totalPages > 1 && (
// // //                   <Pagination 
// // //                     projectsPerPage={projectsPerPage} 
// // //                     totalProjects={filteredProjects.length} 
// // //                     paginate={paginate} 
// // //                     currentPage={currentPage} 
// // //                   />
// // //                 )}

// // //                 <div className="project-list-grid">
// // //                   {currentProjects.map((project) => (
// // //                     <DetailsCard1 
// // //                       key={project.ProjectId} 
// // //                       data={project} 
// // //                       onDownload={handleDownloadSingle}
// // //                     />
// // //                   ))}
// // //                 </div>

// // //                 {totalPages > 1 && (
// // //                   <Pagination 
// // //                     projectsPerPage={projectsPerPage} 
// // //                     totalProjects={filteredProjects.length} 
// // //                     paginate={paginate} 
// // //                     currentPage={currentPage} 
// // //                   />
// // //                 )}
// // //               </>
// // //             )} */}

// // // {filteredProjects.length === 0 ? (
// // //   <div className="catalog-no-results">No projects found matching your criteria.</div>
// // // ) : (
// // //   <>
// // //     {/* Pagination at the top if there are multiple pages */}
// // //     {totalPages > 1 && (
// // //       <Pagination 
// // //         projectsPerPage={projectsPerPage} 
// // //         totalProjects={filteredProjects.length} 
// // //         paginate={paginate} 
// // //         currentPage={currentPage} 
// // //       />
// // //     )}

// // //     {/* Project list grid */}
// // //     <div className="project-list-grid">
// // //       {currentProjects.map((project) => (
// // //         <DetailsCard1 
// // //           key={project.ProjectId} 
// // //           data={project} 
// // //           onDownload={handleDownloadSingle}
// // //         />
// // //       ))}
// // //     </div>

// // //     {/* Pagination at the bottom if there are multiple pages */}
// // //     {totalPages > 1 && (
// // //       <Pagination 
// // //         projectsPerPage={projectsPerPage} 
// // //         totalProjects={filteredProjects.length} 
// // //         paginate={paginate} 
// // //         currentPage={currentPage} 
// // //       />
// // //     )}

// // //     {/* Button to add a project */}
// // //     <div className="add-project-section">
// // //       <button 
// // //         className="add-project-button" 
// // //         onClick={() => window.open("https://docs.google.com/forms/d/e/1FAIpQLSdnzGg9FfuqQq8T0aE2fepNyXytDEVfIzbOn3E7wf3fbvgZxg/viewform", "_blank")}
// // //       >
// // //         Want to add yours?
// // //       </button>
// // //     </div>

// // //     {/* Embedded Google Form iframe */}
// // //     <div className="form-iframe-container">
// // //       <iframe 
// // //         src="https://docs.google.com/forms/d/e/1FAIpQLSdnzGg9FfuqQq8T0aE2fepNyXytDEVfIzbOn3E7wf3fbvgZxg/viewform?embedded=true" 
// // //         width="640" 
// // //         height="1901" 
// // //         frameborder="0" 
// // //         marginheight="0" 
// // //         marginwidth="0"
// // //       >
// // //         Loading…
// // //       </iframe>
// // //     </div>
// // //   </>
// // // )}

// // //           </>
// // //         )}
// // //       </div>
// // //     </div>
// // //   );
// // // };

// // // export default Catalog;











// // import React, { useState, useEffect } from 'react';
// // import axios from 'axios';
// // import './Catalog1.css';
// // import DetailsCard1 from '../detailsCard/DetailsCard1';

// // import Pagination from '../../AllCorrectPages/Pagination/Pagination';
// // import * as XLSX from 'xlsx';

// // const backendURL = process.env.REACT_APP_backend_url;

// // const Catalog = () => {
// //   const [filteredProjects, setFilteredProjects] = useState([]);
// //   const [filters, setFilters] = useState({ Type: '', Department: '', Year: '' });
// //   const [departments, setDepartments] = useState([]);
// //   const [searchPerformed, setSearchPerformed] = useState(false);
// //   const [currentPage, setCurrentPage] = useState(1);
// //   const [loading, setLoading] = useState(false);
// //   const [error, setError] = useState('');
// //   const projectsPerPage = 9;
  
// //   const mtechDepartments = ['CE-SE', 'CE-HE', 'CE-GTE', 'EE-PE', 'EE-PS', 'ME-CC', 'ME-AMS', 'EE-ES', 'EE-VLSI', 'CSE-SE', 'CSE-CNIS', 'EIE', 'CSE'];
// //   const btechDepartments = [
// //     'IT', 'CSE', 'ECE', 'ME', 'EIE', 'CE', 'EEE', 'AIML',
// //     'CS-AIML', 'CS-DS', 'CS-IOT', 'CS-CyS',
// //     'AI & DS', 'CSBS', 'AE'
// //   ];
  
// //   useEffect(() => {
// //     setDepartments(filters.Type === 'MTech-Major' ? mtechDepartments : filters.Type === 'BTech-Major' ? btechDepartments : []);
// //     if (filters.Department) { setFilters(prev => ({ ...prev, Department: '' })); }
// //   }, [filters.Type]);

// //   const handleChange = (e) => {
// //     const { name, value } = e.target;
// //     setFilters(prev => ({ ...prev, [name]: value }));
// //   };

// //   const handleSubmit = async (e) => {
// //     e.preventDefault();
// //     setSearchPerformed(true);
// //     setCurrentPage(1);
// //     setLoading(true);
// //     setError('');
// //     setFilteredProjects([]);
// //     try {
// //       const response = await axios.post(`${backendURL}/filter`, { query: filters }, { 
// //         headers: { 'Content-Type': 'application/json' }
// //       });
// //       setFilteredProjects(Array.isArray(response.data) ? response.data : []);
// //     } catch (err) {
// //       console.error("Error fetching data: ", err);
// //       setError('Failed to fetch projects. Please check network or try again.');
// //       setFilteredProjects([]);
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   const handleDownloadAll = () => {
// //     if (filteredProjects.length === 0) {
// //       alert('No projects to download');
// //       return;
// //     }

// //     const excelData = filteredProjects.map(project => {
// //       const students = project.AdditionalInfo?.StudentNames || 'N/A';
// //       const htNos = project.AdditionalInfo?.HTNos || 'N/A';
      
// //       return {
// //         'Project ID': project.ProjectId,
// //         'Title': project.ProjectTitle,
// //         'Supervisor': project.ProjectSupervisor,
// //         'Department': project.Department,
// //         'Type': project.Project_Type,
// //         'Year': project.Year,
// //         'Domain': project.AdditionalInfo?.Domain || 'N/A',
// //         'Students': students,
// //         'Hall Ticket Numbers': htNos
// //       };
// //     });

// //     const ws = XLSX.utils.json_to_sheet(excelData);
// //     const wb = XLSX.utils.book_new();
// //     XLSX.utils.book_append_sheet(wb, ws, "Projects");
// //     XLSX.writeFile(wb, `Projects_${new Date().toISOString().split('T')[0]}.xlsx`);
// //   };

// //   const handleDownloadSingle = (project) => {
// //     const students = project.AdditionalInfo?.StudentNames || 'N/A';
// //     const htNos = project.AdditionalInfo?.HTNos || 'N/A';
    
// //     const excelData = [{
// //       'Project ID': project.ProjectId,
// //       'Title': project.ProjectTitle,
// //       'Supervisor': project.ProjectSupervisor,
// //       'Department': project.Department,
// //       'Type': project.Project_Type,
// //       'Year': project.Year,
// //       'Domain': project.AdditionalInfo?.Domain || 'N/A',
// //       'Students': students,
// //       'Hall Ticket Numbers': htNos
// //     }];

// //     const ws = XLSX.utils.json_to_sheet(excelData);
// //     const wb = XLSX.utils.book_new();
// //     XLSX.utils.book_append_sheet(wb, ws, "Project");
// //     XLSX.writeFile(wb, `Project_${project.ProjectId}.xlsx`);
// //   };

// //   // Pagination logic
// //   const indexOfLastProject = currentPage * projectsPerPage;
// //   const indexOfFirstProject = indexOfLastProject - projectsPerPage;
// //   const currentProjects = Array.isArray(filteredProjects) ? filteredProjects.slice(indexOfFirstProject, indexOfLastProject) : [];
// //   const totalPages = Array.isArray(filteredProjects) ? Math.ceil(filteredProjects.length / projectsPerPage) : 0;
// //   const paginate = (pageNumber) => { 
// //     if (pageNumber > 0 && pageNumber <= totalPages) { 
// //       setCurrentPage(pageNumber); 
// //       window.scrollTo(0, 0); 
// //     } 
// //   };

// //   return (
// //     <div className="catalog-page-container">
// //       <div className="catalog-filter-card">
// //         <h1 className="catalog-title">Catalog</h1>
// //         <p className="catalog-subtitle">Your Inspiration Starts Here</p>
// //         <form onSubmit={handleSubmit} className="catalog-form">
// //           <div className="filter-item">
// //             <select name="Type" value={filters.Type} onChange={handleChange} className="catalog-select">
// //               <option value="">Select Type</option>
// //               <option value="BTech-Major">BTech-Major</option>
// //               <option value="MTech-Major">MTech-Major</option>
// //             </select>
// //           </div>
// //           <div className="filter-item">
// //             <select name="Department" value={filters.Department} onChange={handleChange} disabled={!filters.Type} className="catalog-select">
// //               <option value="">Select Department</option>
// //               {departments.map((dept) => ( 
// //                 <option key={dept} value={dept}>{dept}</option>
// //               ))}
// //             </select>
// //           </div>
// //           <div className="filter-item">
// //             <select name="Year" value={filters.Year} onChange={handleChange} className="catalog-select">
// //               <option value="">Select Year</option>
// //               {[2024, 2023, 2022, 2021, 2020].map((year) => ( 
// //                 <option key={year} value={year}>{year}</option>
// //               ))}
// //             </select>
// //           </div>
// //           <div className="filter-item">
// //             <button type="submit" disabled={loading} className="catalog-button">
// //               {loading ? 'Filtering...' : 'Filter'}
// //             </button>
// //           </div>
// //           {filteredProjects.length > 0 && (
// //             <div className="filter-item">
// //               <button 
// //                 type="button" 
// //                 onClick={handleDownloadAll}
// //                 disabled={loading}
// //                 className="catalog-button download-all-button"
// //               >
// //                 Download All
// //               </button>
// //             </div>
// //           )}
// //         </form>
// //       </div>

// //       <div className="catalog-results-area">
// //         {loading && <div className="catalog-loading">Loading projects...</div>}
// //         {error && <div className="catalog-error">{error}</div>}
// //         {searchPerformed && !loading && !error && (
// //           <>
// //             {filteredProjects.length === 0 ? (
// //               <>
// //                 <div className="catalog-no-results">No projects found matching your criteria.</div>

// //                 {/* Add Project Button */}
// //                 <div className="add-project-section">
// //                   <button 
// //                     className="add-project-button" 
// //                     onClick={() => window.open("https://docs.google.com/forms/d/e/1FAIpQLSdnzGg9FfuqQq8T0aE2fepNyXytDEVfIzbOn3E7wf3fbvgZxg/viewform", "_blank")}
// //                   >
// //                     Want to add yours?
// //                   </button>
// //                 </div>
// //               </>
// //             ) : (
// //               <>
// //                 {/* Pagination at the top if there are multiple pages */}
// //                 {totalPages > 1 && (
// //                   <Pagination 
// //                     projectsPerPage={projectsPerPage} 
// //                     totalProjects={filteredProjects.length} 
// //                     paginate={paginate} 
// //                     currentPage={currentPage} 
// //                   />
// //                 )}

// //                 {/* Project list grid */}
// //                 <div className="project-list-grid">
// //                   {currentProjects.map((project) => (
// //                     <DetailsCard1 
// //                       key={project.ProjectId} 
// //                       data={project} 
// //                       onDownload={handleDownloadSingle}
// //                     />
// //                   ))}
// //                 </div>

// //                 {/* Pagination at the bottom if there are multiple pages */}
// //                 {totalPages > 1 && (
// //                   <Pagination 
// //                     projectsPerPage={projectsPerPage} 
// //                     totalProjects={filteredProjects.length} 
// //                     paginate={paginate} 
// //                     currentPage={currentPage} 
// //                   />
// //                 )}
// //               </>
// //             )}
// //           </>
// //         )}
// //       </div>
// //     </div>
// //   );
// // };

// // export default Catalog;




// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import './Catalog1.css';
// import DetailsCard1 from '../detailsCard/DetailsCard1';
// import Pagination from '../../AllCorrectPages/Pagination/Pagination';
// import * as XLSX from 'xlsx';

// const backendURL = process.env.REACT_APP_backend_url;

// const Catalog = () => {
//   const [filteredProjects, setFilteredProjects] = useState([]);
//   const [filters, setFilters] = useState({ Type: '', Department: '', Year: '' });
//   const [departments, setDepartments] = useState([]);
//   const [searchPerformed, setSearchPerformed] = useState(false);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');
//   const [searchQuery, setSearchQuery] = useState('');
//   const projectsPerPage = 9;
  
//   const mtechDepartments = ['CE-SE', 'CE-HE', 'CE-GTE', 'EE-PE', 'EE-PS', 'ME-CC', 'ME-AMS', 'EE-ES', 'EE-VLSI', 'CSE-SE', 'CSE-CNIS', 'EIE', 'CSE'];
//   const btechDepartments = [
//     'IT', 'CSE', 'ECE', 'ME', 'EIE', 'CE', 'EEE', 'AIML',
//     'CS-AIML', 'CS-DS', 'CS-IOT', 'CS-CyS',
//     'AI & DS', 'CSBS', 'AE'
//   ];
  
//   useEffect(() => {
//     setDepartments(filters.Type === 'MTech-Major' ? mtechDepartments : filters.Type === 'BTech-Major' ? btechDepartments : []);
//     if (filters.Department) { setFilters(prev => ({ ...prev, Department: '' })); }
//   }, [filters.Type]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFilters(prev => ({ ...prev, [name]: value }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setSearchPerformed(true);
//     setCurrentPage(1);
//     setLoading(true);
//     setError('');
//     setFilteredProjects([]);
//     try {
//       const response = await axios.post(`${backendURL}/filter`, { query: filters }, { 
//         headers: { 'Content-Type': 'application/json' }
//       });
//       setFilteredProjects(Array.isArray(response.data) ? response.data : []);
//     } catch (err) {
//       console.error("Error fetching data: ", err);
//       setError('Failed to fetch projects. Please check network or try again.');
//       setFilteredProjects([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleDownloadAll = () => {
//     if (filteredProjects.length === 0) {
//       alert('No projects to download');
//       return;
//     }

//     const excelData = filteredProjects.map(project => {
//       const students = project.AdditionalInfo?.StudentNames || 'N/A';
//       const htNos = project.AdditionalInfo?.HTNos || 'N/A';
//       return {
//         'Project ID': project.ProjectId,
//         'Title': project.ProjectTitle,
//         'Supervisor': project.ProjectSupervisor,
//         'Department': project.Department,
//         'Type': project.Project_Type,
//         'Year': project.Year,
//         'Domain': project.AdditionalInfo?.Domain || 'N/A',
//         'Students': students,
//         'Hall Ticket Numbers': htNos
//       };
//     });

//     const ws = XLSX.utils.json_to_sheet(excelData);
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, "Projects");
//     XLSX.writeFile(wb, `Projects_${new Date().toISOString().split('T')[0]}.xlsx`);
//   };

//   const handleDownloadSingle = (project) => {
//     const students = project.AdditionalInfo?.StudentNames || 'N/A';
//     const htNos = project.AdditionalInfo?.HTNos || 'N/A';
    
//     const excelData = [{
//       'Project ID': project.ProjectId,
//       'Title': project.ProjectTitle,
//       'Supervisor': project.ProjectSupervisor,
//       'Department': project.Department,
//       'Type': project.Project_Type,
//       'Year': project.Year,
//       'Domain': project.AdditionalInfo?.Domain || 'N/A',
//       'Students': students,
//       'Hall Ticket Numbers': htNos
//     }];

//     const ws = XLSX.utils.json_to_sheet(excelData);
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, "Project");
//     XLSX.writeFile(wb, `Project_${project.ProjectId}.xlsx`);
//   };

//   // Client-side search: whole-word matching
//   const filteredAndSearchedProjects = Array.isArray(filteredProjects)
//     ? filteredProjects.filter(project => {
//         if (!searchQuery.trim()) return true; // show all if empty

//         const queryWords = searchQuery.toLowerCase().split(/\s+/);
//         const searchableText = `${project.ProjectTitle} ${project.ProjectSupervisor || ''} ${project.Department || ''}`.toLowerCase();

//         // Early exit if any word matches exactly
//         return queryWords.some(word => searchableText.split(/\s+/).includes(word));
//       })
//     : [];

//   // Pagination logic
//   const indexOfLastProject = currentPage * projectsPerPage;
//   const indexOfFirstProject = indexOfLastProject - projectsPerPage;
//   const currentProjects = filteredAndSearchedProjects.slice(indexOfFirstProject, indexOfLastProject);
//   const totalPages = Math.ceil(filteredAndSearchedProjects.length / projectsPerPage);
//   const paginate = (pageNumber) => { 
//     if (pageNumber > 0 && pageNumber <= totalPages) { 
//       setCurrentPage(pageNumber); 
//       window.scrollTo(0, 0); 
//     } 
//   };

//   return (
//     <div className="catalog-page-container">
//       <div className="catalog-filter-card">
//         <h1 className="catalog-title">Catalog</h1>
//         <p className="catalog-subtitle">Your Inspiration Starts Here</p>
//         <form onSubmit={handleSubmit} className="catalog-form">
//           <div className="filter-item">
//             <select name="Type" value={filters.Type} onChange={handleChange} className="catalog-select">
//               <option value="">Select Type</option>
//               <option value="BTech-Major">BTech-Major</option>
//               <option value="MTech-Major">MTech-Major</option>
//             </select>
//           </div>
//           <div className="filter-item">
//             <select name="Department" value={filters.Department} onChange={handleChange} disabled={!filters.Type} className="catalog-select">
//               <option value="">Select Department</option>
//               {departments.map((dept) => ( 
//                 <option key={dept} value={dept}>{dept}</option>
//               ))}
//             </select>
//           </div>
//           <div className="filter-item">
//             <select name="Year" value={filters.Year} onChange={handleChange} className="catalog-select">
//               <option value="">Select Year</option>
//               {[2024, 2023, 2022, 2021, 2020].map((year) => ( 
//                 <option key={year} value={year}>{year}</option>
//               ))}
//             </select>
//           </div>
//           <div className="filter-item">
//             <input
//               type="text"
//               placeholder="Search within results"
//               value={searchQuery}
//               onChange={(e) => setSearchQuery(e.target.value)}
//               className="catalog-search-input"
//             />
//           </div>
//           <div className="filter-item">
//             <button type="submit" disabled={loading} className="catalog-button">
//               {loading ? 'Filtering...' : 'Filter'}
//             </button>
//           </div>
//           {filteredProjects.length > 0 && (
//             <div className="filter-item">
//               <button 
//                 type="button" 
//                 onClick={handleDownloadAll}
//                 disabled={loading}
//                 className="catalog-button download-all-button"
//               >
//                 Download All
//               </button>
//             </div>
//           )}
//         </form>
//       </div>

//       <div className="catalog-results-area">
//         {loading && <div className="catalog-loading">Loading projects...</div>}
//         {error && <div className="catalog-error">{error}</div>}
//         {searchPerformed && !loading && !error && (
//           <>
//             {filteredAndSearchedProjects.length === 0 ? (
//               <>
//                 <div className="catalog-no-results">No projects found matching your criteria.</div>
//                 <div className="add-project-section">
//                   <button 
//                     className="add-project-button" 
//                     onClick={() => window.open("https://docs.google.com/forms/d/e/1FAIpQLSdnzGg9FfuqQq8T0aE2fepNyXytDEVfIzbOn3E7wf3fbvgZxg/viewform", "_blank")}
//                   >
//                     Want to add yours?
//                   </button>
//                 </div>
//               </>
//             ) : (
//               <>
//                 {totalPages > 1 && (
//                   <Pagination 
//                     projectsPerPage={projectsPerPage} 
//                     totalProjects={filteredAndSearchedProjects.length} 
//                     paginate={paginate} 
//                     currentPage={currentPage} 
//                   />
//                 )}

//                 <div className="project-list-grid">
//                   {currentProjects.map((project) => (
//                     <DetailsCard1 
//                       key={project.ProjectId} 
//                       data={project} 
//                       onDownload={handleDownloadSingle}
//                     />
//                   ))}
//                 </div>

//                 {totalPages > 1 && (
//                   <Pagination 
//                     projectsPerPage={projectsPerPage} 
//                     totalProjects={filteredAndSearchedProjects.length} 
//                     paginate={paginate} 
//                     currentPage={currentPage} 
//                   />
//                 )}
//               </>
//             )}
//           </>
//         )}
//       </div>
//     </div>
//   );
// };

// export default Catalog;


import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import './Catalog1.css';
import DetailsCard1 from '../detailsCard/DetailsCard1';
import Pagination from '../../AllCorrectPages/Pagination/Pagination';
import * as XLSX from 'xlsx';

const backendURL = process.env.REACT_APP_backend_url;

const Catalog = () => {
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [filters, setFilters] = useState({ Type: '', Department: '', Year: '' });
  const [departments, setDepartments] = useState([]);
  const [searchPerformed, setSearchPerformed] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [searchInput, setSearchInput] = useState('');
  const projectsPerPage = 9;
  const resultsRef = useRef(null);

  const mtechDepartments = ['CE-SE', 'CE-HE', 'CE-GTE', 'EE-PE', 'EE-PS', 'ME-CC', 'ME-AMS', 'EE-ES', 'EE-VLSI', 'CSE-SE', 'CSE-CNIS', 'EIE', 'CSE'];
  const btechDepartments = [
    'IT', 'CSE', 'ECE', 'ME', 'EIE', 'CE', 'EEE', 'AIML',
    'CS-AIML', 'CS-DS', 'CS-IOT', 'CS-CyS',
    'AI & DS', 'CSBS', 'AE'
  ];

  // Update departments based on selected type
  useEffect(() => {
    setDepartments(filters.Type === 'MTech-Major' ? mtechDepartments : filters.Type === 'BTech-Major' ? btechDepartments : []);
    if (filters.Department) setFilters(prev => ({ ...prev, Department: '' }));
  }, [filters.Type]);

  // Handle filter input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
  };

  // Handle filter submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSearchPerformed(true);
    setCurrentPage(1);
    setLoading(true);
    setError('');
    setFilteredProjects([]);
    try {
      const response = await axios.post(`${backendURL}/filter`, { query: filters }, {
        headers: { 'Content-Type': 'application/json' }
      });
      setFilteredProjects(Array.isArray(response.data) ? response.data : []);
      resultsRef.current?.scrollIntoView({ behavior: "smooth" });
    } catch (err) {
      console.error("Error fetching data: ", err);
      setError('Failed to fetch projects. Please check network or try again.');
      setFilteredProjects([]);
    } finally {
      setLoading(false);
    }
  };

  // Handle Enter key in search
  const handleSearchEnter = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      setSearchQuery(searchInput);
      setCurrentPage(1);
      resultsRef.current?.scrollIntoView({ behavior: "smooth" });
    }
  };

  // Download all filtered projects as Excel
  const handleDownloadAll = () => {
    if (filteredProjects.length === 0) {
      alert('No projects to download');
      return;
    }

    const excelData = filteredProjects.map(project => {
      const students = project.AdditionalInfo?.StudentNames || 'N/A';
      const htNos = project.AdditionalInfo?.HTNos || 'N/A';
      return {
        'Project ID': project.ProjectId,
        'Title': project.ProjectTitle,
        'Supervisor': project.ProjectSupervisor,
        'Department': project.Department,
        'Type': project.Project_Type,
        'Year': project.Year,
        'Domain': project.AdditionalInfo?.Domain || 'N/A',
        'Students': students,
        'Hall Ticket Numbers': htNos
      };
    });

    const ws = XLSX.utils.json_to_sheet(excelData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Projects");
    XLSX.writeFile(wb, `Projects_${new Date().toISOString().split('T')[0]}.xlsx`);
  };

  // Download single project as Excel
  const handleDownloadSingle = (project) => {
    const students = project.AdditionalInfo?.StudentNames || 'N/A';
    const htNos = project.AdditionalInfo?.HTNos || 'N/A';

    const excelData = [{
      'Project ID': project.ProjectId,
      'Title': project.ProjectTitle,
      'Supervisor': project.ProjectSupervisor,
      'Department': project.Department,
      'Type': project.Project_Type,
      'Year': project.Year,
      'Domain': project.AdditionalInfo?.Domain || 'N/A',
      'Students': students,
      'Hall Ticket Numbers': htNos
    }];

    const ws = XLSX.utils.json_to_sheet(excelData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Project");
    XLSX.writeFile(wb, `Project_${project.ProjectId}.xlsx`);
  };

  // Client-side search (whole-word matching)
  const filteredAndSearchedProjects = Array.isArray(filteredProjects)
    ? filteredProjects.filter(project => {
        if (!searchQuery.trim()) return true;
        const queryWords = searchQuery.toLowerCase().split(/\s+/);
        const searchableText = `${project.ProjectTitle} ${project.ProjectSupervisor || ''} ${project.Department || ''}`.toLowerCase();
        return queryWords.some(word => searchableText.split(/\s+/).includes(word));
      })
    : [];

  // Pagination
  const indexOfLastProject = currentPage * projectsPerPage;
  const indexOfFirstProject = indexOfLastProject - projectsPerPage;
  const currentProjects = filteredAndSearchedProjects.slice(indexOfFirstProject, indexOfLastProject);
  const totalPages = Math.ceil(filteredAndSearchedProjects.length / projectsPerPage);

  const paginate = (pageNumber) => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
      resultsRef.current?.scrollIntoView({ behavior: "smooth" });
    }
  };

  // Auto-refresh if no projects found after search
  useEffect(() => {
    if (searchPerformed && filteredAndSearchedProjects.length === 0) {
      const timer = setTimeout(() => {
        window.location.reload();
      }, 2000); // 2-second delay
      return () => clearTimeout(timer);
    }
  }, [searchPerformed, filteredAndSearchedProjects]);

  return (
    <div className="catalog-page-container">
      <div className="catalog-filter-card">
        <h1 className="catalog-title">Catalog</h1>
        <p className="catalog-subtitle">Your Inspiration Starts Here</p>
        <form onSubmit={handleSubmit} className="catalog-form">
          <div className="filter-item">
            <select name="Type" value={filters.Type} onChange={handleChange} className="catalog-select">
              <option value="">Select Type</option>
              <option value="BTech-Major">BTech-Major</option>
              <option value="MTech-Major">MTech-Major</option>
            </select>
          </div>
          <div className="filter-item">
            <select name="Department" value={filters.Department} onChange={handleChange} disabled={!filters.Type} className="catalog-select">
              <option value="">Select Department</option>
              {departments.map((dept) => <option key={dept} value={dept}>{dept}</option>)}
            </select>
          </div>
          <div className="filter-item">
            <select name="Year" value={filters.Year} onChange={handleChange} className="catalog-select">
              <option value="">Select Year</option>
              {[2024, 2023, 2022, 2021, 2020].map((year) => <option key={year} value={year}>{year}</option>)}
            </select>
          </div>
          <div className="filter-item">
            <button type="submit" disabled={loading} className="catalog-button">
              {loading ? 'Filtering...' : 'Filter'}
            </button>
          </div>
          {filteredProjects.length > 0 && (
            <div className="filter-item">
              <button type="button" onClick={handleDownloadAll} disabled={loading} className="catalog-button download-all-button">
                Download All
              </button>
            </div>
          )}
        </form>
      </div>

      <div className="catalog-results-area" ref={resultsRef}>
        {loading && <div className="catalog-loading">Loading projects...</div>}
        {error && <div className="catalog-error">{error}</div>}

        {searchPerformed && !loading && !error && (
          <>
            {filteredAndSearchedProjects.length === 0 ? (
              <div className="catalog-no-results">
                No projects found matching your criteria. Refreshing...
              </div>
            ) : (
              <>
                <div className="search-filter">
                  <input
                    type="text"
                    placeholder="Search within results"
                    value={searchInput}
                    onChange={(e) => setSearchInput(e.target.value)}
                    onKeyDown={handleSearchEnter}
                    className="catalog-search-input"
                  />
                  {searchQuery && (
                    <button type="button" className="clear-search-button" onClick={() => {
                      setSearchInput('');
                      setSearchQuery('');
                      setCurrentPage(1);
                    }}>
                      X
                    </button>
                  )}
                </div>

                {totalPages > 1 && (
                  <Pagination
                    projectsPerPage={projectsPerPage}
                    totalProjects={filteredAndSearchedProjects.length}
                    paginate={paginate}
                    currentPage={currentPage}
                  />
                )}

                <div className="project-list-grid">
                  {currentProjects.map(project => (
                    <DetailsCard1 key={project.ProjectId} data={project} onDownload={handleDownloadSingle} />
                  ))}
                </div>

                {totalPages > 1 && (
                  <Pagination
                    projectsPerPage={projectsPerPage}
                    totalProjects={filteredAndSearchedProjects.length}
                    paginate={paginate}
                    currentPage={currentPage}
                  />
                )}
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Catalog;